/**
 * Read-only preview of a frozen HTML mail (DEV-93).
 *
 * The HTML was rendered from the draft when it was queued and is stored on the
 * notification, so it is shown in a sandboxed frame — no scripts, no access to
 * the app — and never injected into the page itself.
 */
import type { ReactNode } from 'react';

export function MailPreview({ html, title }: Readonly<{ html: string; title: string }>): ReactNode {
  return <iframe className="mail-html-preview" sandbox="" srcDoc={html} title={title} />;
}

export default MailPreview;
